import { axiosInstance } from "../instance"

export const GET_DATABASE_TYPES = () => axiosInstance.get("/database-types")

export const GET_CURRENT_DATABASE_TYPES = id =>
  axiosInstance.get(`/database-types/${id}`)
